var PromoTab = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_promo_tab',
	},

	initialize: function(_element, options){
		this.setOptions(options);
		this._element = _element;

		if(this._element){
			this.build();
		}
	},

	build: function(){
		var self = this;
		var fcls = '.' + this.options.cls;
		this._option_tabs = this._element.getElements(fcls + '_options li');
		this._active_tab = this._element.getElement(fcls + '_options li._active');
		this._close_option = this._element.getElement('.close');
		this.total_height = window.scrollMaxY;

		if(!this.total_height){
			this.total_height = document.body.scrollHeight;
		}

		this.total_height -= self._element.getPosition().y;
		this.mid_height = this.total_height;

		this.set_display_counts();

		if(this.display_count >= 10){
			this._element.dispose();
			return;
		}

		this.set_position();
		this.set_functionality();

		window.addEvent('scroll', function(e, _e){
			if(document.body.getScroll().y > 0){
				if(self._active_tab._container.status && self._active_tab._container.status == 'open') return;

				self._element.fade('in');
				self._active_tab._container.status = 'open';
			}
			else{
				if(self._active_tab._container.status && self._active_tab._container.status == 'close') return;

				self._element.fade('out');
				self._active_tab._container.status = 'close';
			}
		})

		// by default, the active tab is how cr can help you.
		this._element.fade('out');
		this._active_tab.fireEvent('click');
	},

	set_display_counts: function(){
		var cookie_display_count = Cookie.read('crPromoTabDisplayCounts');

		if(document.body.get('id') != 'bov') return

		if(cookie_display_count && cookie_display_count <= 10){
			cookie_display_count++;
			Cookie.write('crPromoTabDisplayCounts', cookie_display_count);
		}
		else{
			Cookie.write('crPromoTabDisplayCounts', 1);
		}

		this.display_count = (cookie_display_count)? cookie_display_count : 1;
	},

	set_position: function(){
		var _footer = document.getElement('#footer');

		this._element.inject(_footer, 'after');
	},

	set_functionality: function(){
		var self = this;

		this._option_tabs.each(function(_tab){

			self.set_container(_tab);

			_tab.addEvents({
				'click': function(){
					if(self._active_tab){
						self._active_tab.removeClass('_active');
						self._active_tab._container.hide();
					}

					_tab.addClass('_active');
					_tab._container.show();

					self._active_tab = _tab;
				}
			})
		})

		this._close_option.addEvent('click', function(){
			self._active_tab._container.hide();
			self._active_tab.removeClass('_active');
		})
	},

	set_container: function(_tab){
		var _container = this._element.getElement('.' + _tab.get('data-container'));

		_tab._container = _container;

		this.get_content(_tab);
	},

	get_content: function(_tab){
		var self = this;
		var rpc = _tab.getAttribute('data-rpc');

		if(!rpc || rpc == '') return;

		new Request.JSON({
			url: rpc,
			onSuccess: function(data){
				var _content = _tab._container;

				if(_content){
					_content.set('html', data.content);

					self.initialize_widgets(_tab._container);
				}
			}
		}).send();
	},

	initialize_widgets: function(_container){
		var _imagestrip = _container.getElement('.w_imagestrip');
		if(_imagestrip){
			new Imagestrip(_imagestrip, {
				auto_move: false,
				amount: 4,
				dynamic: true,
				display_items: 4
			});


			_imagestrip.addEvents({
				'click:relay(.w_imagestrip_image_legend, .w_imagestrip_image, .name)': function(e){
					if(e && e.stop) e.stop();

					Cookie.write('crFromBuildingPromo', 'yes');

					var url;
					if(this.get('href')){
						url = this.get('href');
					}
					else{
						url = this.getParent('.anchornator').getElement('a').get('href');
					}

					window.location = url;
				}
			})

			//Core.add_anchornator_support(imagestrip._photos);
		}

		var _popup = _container.getElement('.w_popup');
		if(_popup){
			new Blimp.Form(_popup, {
				build: function(blimp_form){
					if(Blimp.Form.instances && Blimp.Form.instances.contains(blimp_form)){
						return;
					}

					blimp_form._element = _container.getElement('.w_popup.email');
					blimp_form.post_process();

					Blimp.Form.instances.include(blimp_form);
				},
				post_process_build: false,
				keep_form_on_success: true,
				auto_hide_form: false
			});
		}
	}
});
